import { useCallback, useMemo } from "react";
import { api } from "@/api";

// Phase 82 — accès au site du propriétaire connecté, ou à n'importe quel site pour l'admin (`?sid=`)
export function useWebApi(sid) {
  const u = useCallback((path = "") => {
    const base = `/web/site${path}`;
    if (!sid) return base;
    return `${base}${base.includes("?") ? "&" : "?"}sid=${encodeURIComponent(sid)}`;
  }, [sid]);
  return useMemo(() => ({
    u,
    get: (p = "", cfg) => api.get(u(p), cfg),
    put: (p = "", body, cfg) => api.put(u(p), body, cfg),
    post: (p = "", body, cfg) => api.post(u(p), body, cfg),
    patch: (p = "", body, cfg) => api.patch(u(p), body, cfg),
    del: (p = "", cfg) => api.delete(u(p), cfg),
  }), [u]);
}

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export function mediaUrl(url) {
  if (!url) return "";
  return url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;
}
export function money(v, currency = "EUR") {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency, minimumFractionDigits: 2 }).format(Number(v || 0));
}
